var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPurchasingManagementFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_98013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 15.8334C3.33337 16.2754 3.50897 16.6994 3.82153 17.0119C4.13409 17.3245 4.55801 17.5001 5.00004 17.5001C5.44207 17.5001 5.86599 17.3245 6.17855 17.0119C6.49111 16.6994 6.66671 16.2754 6.66671 15.8334C6.66671 15.3914 6.49111 14.9675 6.17855 14.6549C5.86599 14.3423 5.44207 14.1667 5.00004 14.1667C4.55801 14.1667 4.13409 14.3423 3.82153 14.6549C3.50897 14.9675 3.33337 15.3914 3.33337 15.8334Z",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H5.00004V2.5H3.33337",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4.16675L16.6667 5.00008L16.0083 9.60508M13.3333 10.8334H5",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1219_98013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1675 15.8334C14.1675 16.2754 14.3431 16.6994 14.6556 17.0119C14.9682 17.3245 15.3921 17.5001 15.8341 17.5001C16.2762 17.5001 16.7001 17.3245 17.0127 17.0119C17.3252 16.6994 17.5008 16.2754 17.5008 15.8334C17.5008 15.3914 17.3252 14.9675 17.0127 14.6549C16.7001 14.3423 16.2762 14.1667 15.8341 14.1667C15.3921 14.1667 14.9682 14.3423 14.6556 14.6549C14.3431 14.9675 14.1675 15.3914 14.1675 15.8334Z",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8341 12.9167V14.1667",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8341 17.5V18.75",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 14.375L17.2775 15",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3917 16.6667L13.3083 17.2917",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3083 14.375L14.3917 15",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2775 16.6667L18.3608 17.2917",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1219_98013",
    x: 9.3175,
    y: 13.3167,
    width: 13.0333,
    height: 13.0334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1219_98013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1219_98013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_98013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPurchasingManagementFocus);
export default __webpack_public_path__ + "static/media/svg_purchasing_management_focus.829e2a8cf82ee5e8153cb520674db0f0.svg";
export { ForwardRef as ReactComponent };